import React from "react";
import { observer } from "mobx-react-lite";
import SelectedOrderPayments from "./SelectedOrderPayments";
import OrderDTO from "@/dto/order/OrderDTO";

interface SelectedOrderInfoProps {
    selectedOrders: OrderDTO[];
}

const SelectedOrderInfo: React.FC<SelectedOrderInfoProps> = function (props) {
    const { selectedOrders } = props;

    const selectedOrderCount = selectedOrders?.length;

    return (
        <span className="selected-orders-count">
            选中 {selectedOrderCount} 个
            {selectedOrderCount ? <SelectedOrderPayments selectedOrders={selectedOrders} /> : null}
        </span>
    );
};

export default observer(SelectedOrderInfo);
